import { Box, useTheme } from "@mui/material";

import { DecorativeLottie } from "@/common/components/DecorativeLottie/DecorativeLottie";
import { useTranslate } from "@/common/hooks/useTranslate";
import { useFetchZeffyLoaderAnimation } from "@/forms-design-system/FormZeffyLoader/useFetchZeffyLoaderAnimation";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface FormZeffyLoaderProps {
  size?: "small" | "medium" | "large";
}

const HEIGHT_BY_SIZE = {
  small: 28,
  medium: 36,
  large: 100,
};

export const FormZeffyLoader = ({ size = "medium" }: FormZeffyLoaderProps) => {
  const theme = useTheme();
  const { t } = useTranslate();

  const animationData = useFetchZeffyLoaderAnimation(
    theme.palette.formsComponents?.zeffyLoader?.color ?? "hsl(0, 0%, 0%)" // Should never happen, unless the theme is not set
  );

  if (!theme.palette.forms || !theme.palette.formsComponents?.zeffyLoader) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box
      role="status"
      aria-label={t("common", "loading")}
      sx={{
        height: HEIGHT_BY_SIZE[size],
        "& svg": { width: "unset !important" },
      }}
    >
      <DecorativeLottie options={{ animationData }} style={{ height: "100%" }} isClickToPauseDisabled={true} />
    </Box>
  );
};
